<template>
    <b-modal id="modal-approove-user-ovp"
            hide-footer no-close-on-backdrop body-class="p-2" 
            header-class="bg-light align-items-center"
            size="xl">
        <div slot="modal-title">
            <h3 class="h4 text-dark font-weight-light m-0">OVP darba apstākļu apstiprināšana</h3>
        </div>
        <div slot="modal-header-close">
        </div>
        <UserOvpJobConditionConfirmBaseForm 
                :ready-to-be-approved-ovps="waitingForApprovalOvps" 
                @finished="handleOvpJobConditionApproval"
                />
                
    </b-modal>
</template>
<script>
import { User } from '../../../../vuex/modules/user/models/user.models';
import UserOvpJobConditionConfirmBaseForm from '../UserOvpJobConditionConfirmBaseForm';

export default {
    name: 'user-ovp-approove-modal',
    components: {UserOvpJobConditionConfirmBaseForm},
    props: {
        user: {
            type: User,
        }
    },
    computed: {
        waitingForApprovalOvps() {
            return !this.user ? [] : this.user.ovpJobConditions.filter(({waitingForApproval}) => waitingForApproval);
        }
    },
    methods: {
        async handleOvpJobConditionApproval() {
            this.$bvModal.hide('modal-approove-user-ovp')
        },
    }
}
</script>